'use client'

import { motion } from 'motion/react'
import { Upload } from 'lucide-react'
import { cn } from '@/lib/utils'
import { UsePromptFormReturn } from '@/lib/types'
import { PromptAreaTextarea } from '@/components/prompt-area/prompt-area-textarea'
import { ModelSelectorContainer } from '@/components/prompt-area/model-selector'
import { PromptAreaFileUpload } from '@/components/prompt-area/prompt-area-file-upload'
import { AnimatedButton } from '@/components/ui/animated-button'

export function PromptAreaText({
    promptForm,
    requestInProgress
}: {
    promptForm: UsePromptFormReturn
    requestInProgress: boolean
}) {
    return (
        <div className={cn(
            'flex flex-col gap-2 w-full relative border border-border rounded-lg p-2 bg-background8 transition-all duration-200 ease-in-out',
            promptForm.isDragActive && 'ring-0 ring-primary ring-offset-0 bg-primary/5',
            promptForm.isTextAreaFocused && 'border-ring border'
        )}>
            <PromptAreaTextarea promptForm={promptForm} />

            <div className="flex flex-row items-center justify-between">
                <ModelSelectorContainer
                    model={promptForm.formValues.model}
                    onModelChange={promptForm.handleModelChange}
                    modelType={'text'}
                />

                <div className="flex flex-row items-center gap-2">
                    <PromptAreaFileUpload promptForm={promptForm} />
                    <AnimatedButton
                        lottieIcon="send"
                        type="submit"
                        size="icon"
                        animationTrigger='motion-complete'
                        className="h-8 w-8 bg-primary flex items-center justify-center"
                        disabled={promptForm.isUploading || requestInProgress}
                    />
                </div>
            </div>

            {promptForm.isDragActive && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    className="absolute inset-0 flex items-center justify-center bg-primary/20 rounded-lg border-2 border-dashed border-primary z-10"
                >
                    <div className="text-center">
                        <Upload className="h-8 w-8 mx-auto mb-2 text-primary" />
                        <p className="text-sm font-medium text-primary">Drop files here to upload</p>
                    </div>
                </motion.div>
            )}
        </div>
    )
}


